import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { logout } from "../../../reducers/auth.reducer";
import { selectCharacter } from "../../../reducers/character.reducer";
import styles from "./nav.bar.module.css";

const CHARACTER_ROUTES = ["/character", "/journal", "/spells", "/inventory"];

const NavBar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectedCharacterId = useSelector(
    (state) => state.character.selectedCharacterId
  );
  const isAdmin = useSelector((state) => state.auth.user?.roles?.includes("ADMIN"));
  const isCharacterMode =
    Boolean(selectedCharacterId) &&
    CHARACTER_ROUTES.some((route) => location.pathname.startsWith(route));
  const linkClassName = ({ isActive }) =>
    `${styles.link}${isActive ? ` ${styles.active}` : ""}`;

  const exitCharacter = () => {
    dispatch(selectCharacter(null));
    navigate("/characters");
  };

  const logOut = () => {
    dispatch(selectCharacter(null));
    dispatch(logout());
  };

  return (
    <nav className={styles.container}>
      {isCharacterMode ? (
        <>
          <NavLink className={linkClassName} to="/character">
            {t("nav.character")}
          </NavLink>
          <NavLink className={linkClassName} to="/journal">
            {t("nav.journal")}
          </NavLink>
          <NavLink className={linkClassName} to="/spells">
            {t("nav.spells")}
          </NavLink>
          <NavLink className={linkClassName} to="/inventory">
            {t("nav.inventory")}
          </NavLink>
          <button
            className={`${styles.link} ${styles.action}`}
            type="button"
            onClick={exitCharacter}
          >
            {t("nav.exitCharacter")}
          </button>
        </>
      ) : (
        <>
          <NavLink className={linkClassName} to="/characters">
            {t("nav.characters")}
          </NavLink>
          <NavLink className={linkClassName} to="/campaigns">
            {t("nav.campaigns")}
          </NavLink>
          <NavLink className={linkClassName} to="/profile">
            {t("nav.profile")}
          </NavLink>
          {isAdmin && (
            <NavLink className={linkClassName} to="/admin">
              {t("nav.admin")}
            </NavLink>
          )}
          <NavLink className={styles.link} to="/auth/login" onClick={logOut}>
            {t("nav.logout")}
          </NavLink>
        </>
      )}
    </nav>
  );
};

export default NavBar;
